import styled from "styled-components";
import spinnerImg from "../../assets/images/spinner.svg";
import whiteSpinnerImg from "../../assets/images/whiteSpinner.svg";
import SVG from "../ui/SVG";
import { fullRotate } from "../../utils/animations";

const Container = styled(SVG)/* <{ $loading: boolean }> */ `
  width: 20px;
  height: 20px;

  animation: ${fullRotate} 1s linear infinite;
`;

type TSpinnerProps = {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: "rose" | "white";
};

const Spinner: React.FC<TSpinnerProps> = ({
  /* loading */
  className,
  id,
  style,
  color = "rose",
}) => {
  return (
    <Container
      style={style}
      className={className}
      id={id}
      src={
        color === "rose" ? spinnerImg : whiteSpinnerImg
      } /* $loading={loading} */
    />
  );
};

export default Spinner;
